<template>
  <div class="homeBox">
    <van-pull-refresh v-model="refresh" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t.noMoreData"
        class="homeContent"
        @load="onLoad"
      >
        <home-swiper :images="images"></home-swiper>
        <!-- 轮播图已接数据完毕  无点击事件-->

        <profitable :ListViewOddsProduct="ListViewOddsProduct"></profitable>
        <!-- profitable已接数据  部分数据没有 比如打折,Usd。无点击事件-->

        <div class="promo">
          <div @click="move">{{ $t.meta.allPromotions }}</div>
        </div>

        <div class="message" @click="goMessages">
          <div class="message-div" @click.stop="getAllProduct">
            <img class="message-div-more" :src="icon_1img" alt />
          </div>
          <div class="message-center">
            {{ $t.meta.messageText(messageAmount) }}
          </div>
          <div class="message-check" @click="goMessage">
            {{ $t.meta.checkNow }}
          </div>
        </div>
        <!-- 无数据 无点击事件 -->

        <personal :ListViewOddsClass="ListViewOddsClass"></personal>
        <!-- personal已链接数据 无detail图/文 //无点击事件 -->

        <van-cheen :ListProduct="ListProduct"></van-cheen>
        <!-- van-cheen已链接数据  无点击事件/往下拉 -->
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem, Sticky, List, PullRefresh } from "vant";
import { isAPP, getPlatform } from "@/plugins/environment/type.js";
Vue.use(Swipe).use(SwipeItem).use(List).use(Sticky);

import HomeSwiper from "./components/HomeSwiper";
import Profitable from "./components/Profitable";
import Personal from "./components/Personal";
import VanCheen from "./components/VanCheen";

export default {
  name: "Home",
  components: {
    HomeSwiper,
    Profitable,
    Personal,
    VanCheen,
    "van-pull-refresh": PullRefresh,
  },
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      refresh: false,
      loading: true,
      images: [],
      ListViewOddsProduct: [],
      ListProduct: [],
      finished: false,
      pageIndex: 1,
      ListViewOddsClass: [],
      icon_1img: require("../../../assets/img/home/icon_1.png"),
      messageAmount: 0,
    };
  },
  mounted() {
    this.$bus.$off("HomeRefresh").$on("HomeRefresh", (isRefresh) => {
      if (isRefresh) {
        this.onRefresh();
      }
    });
    this.loadIndex();
  },
  methods: {
    move() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "search",
        name: "search",
        query: [],
      });
    },
    goMessages() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "messages",
        name: "Messages",
        query: [],
      });
    },
    goMessage() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "messages",
        name: "Messages",
        query: [],
      });
    },
    onRefresh() {
      this.pageIndex = 1;
      this.refresh = true;
      this.loadIndex(true)
        .then(() => {
          this.refresh = false;
        })
        .catch(() => {
          this.refresh = false;
        });
    },
    // 获取首页数据
    loadIndex(hideLoading = false) {
      return new Promise((resolve, reject) => {
        if (!hideLoading) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showLoading);
        }
        let param = {};
        this.$api.index
          .loadNewIndex(param)
          .then((res) => {
            const data = res.data;
            this.images = data.ListViewAdverts;
            this.ListViewOddsProduct = data.ListViewOddsProduct;
            this.ListProduct = data.ListProduct;
            this.ListViewOddsClass = data.ListViewOddsClass;
            this.messageAmount = data.MessageAmount;
            if (
              data.ListProduct === null ||
              data.ListProduct === "" ||
              data.ListProduct.length === 0
            ) {
              this.isPlaceholder = true;
            } else {
              this.isPlaceholder = false;
            }
            this.loading = false;
            if (!hideLoading) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
            }
            resolve();
          })
          .catch((error) => {
            this.loading = false;
            if (!hideLoading) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.hideLoading);
            }
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
              status: error.status,
            });
            reject();
          });
      });
    },
    //加载更多
    onLoad() {
      let param = {};
      if (this.ListProduct !== 1) {
        param = {
          pageIndex: this.pageIndex + 1,
        };
      }
      this.$api.index
        .loadClassProductByPage(param)
        .then((res) => {
          const data = res.data;
          if (data.length === 0) {
            this.loading = false;
            this.finished = true;
          } else {
            this.loading = false;
            this.ListProduct = this.ListProduct.concat(res.data);
            this.pageIndex = this.pageIndex + 1;
          }
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
    //获取更多商品
    getAllProduct() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "allProducts",
        name: "AllProducts",
        query: [],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.homeBox {
  height: 100%;
  .van-pull-refresh {
    overflow: unset;
  }
  .homeContent {
    display: inline-block;
    width: 100%;
  }
  .promo {
    text-align: right;
    margin: 15px 20px 0 0;
    font-size: 14px;
    color: #0090e6;
  }
  .message {
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-display: flex;
    -webkit-justify-content: space-between;
    -webkit-align-items: center;
    width: 95%;
    margin: 10px auto;
    background: #fff;
    box-shadow: 0px 3px 3px 3px #dadada;
    font-size: 14px;
    padding: 10px;
    border-radius: 20px;
    box-sizing: border-box;

    img {
      width: 25px;
      height: 25px;
    }

    &-div {
      margin-left: 5px;
      margin-right: 10px;
      line-height: 50px;
      display: flex;
      align-content: center;
      justify-content: center;
      &-more {
        width: 35px !important;
        height: 35px !important;
      }
    }
    &-center {
      color: #585a57;
      flex: 1;
      // font-weight: bold;
      span {
        color: #ed6926;
      }
    }
    &-check {
      color: #0090e6;
      margin-right: 10px;
    }
  }
}
</style>
